import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api, setAccessToken } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { useCapturedParams } from "../../lib/cleanUrl";

export default function MagicLink() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const once = useRef(false);
  const { token } = useCapturedParams();
  useEffect(() => {
    if (!token || once.current) return;
    once.current = true;
    setMsg("Signing you in…");
    api.post("/auth/magic-link/verify", { token })
      .then((r) => { setAccessToken(r.data.access_token); window.location.replace("/client/portal"); })
      .catch((e) => { setMsg(null); setError(e?.response?.data?.detail?.message || "This sign-in link is invalid or has expired."); });
  }, [token]);
  const submit = (e) => {
    e.preventDefault();
    setBusy(true);
    api.post("/auth/magic-link/request", { email })
      .then((r) => { setMsg(r.data.message); setError(null); })
      .catch(() => setError("Something went wrong. Try again or sign in with your password."))
      .finally(() => setBusy(false));
  };
  return (
    <main className="min-h-screen bg-[#FEFCF7] px-6 py-16 font-nav text-erf-dark" data-testid="magic-link-page">
      <div className="mx-auto max-w-md space-y-5">
        <h1 className="font-display text-4xl font-semibold">Client portal sign-in link</h1>
        <p className="text-sm">Enter the email ERF has on file for your client portal account. We'll email a link that works once and expires in 15 minutes.</p>
        <form onSubmit={submit} className="space-y-3">
          <label className="block text-sm">Email<Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-11" data-testid="magic-link-email" /></label>
          <Button type="submit" disabled={busy} className="h-11 bg-erf-dark text-[#FEFCF7]" data-testid="magic-link-send">{busy ? "Sending…" : "Email me a sign-in link"}</Button>
        </form>
        {msg && <p role="status" data-testid="magic-link-msg">{msg}</p>}
        {error && <p role="alert" className="text-[#991B1B]" data-testid="magic-link-error">{error}</p>}
        <Link to="/login" className="inline-flex min-h-[44px] items-center underline" data-testid="magic-link-password">Sign in with your password instead</Link>
      </div>
    </main>
  );
}
